























































































































































































































































































































































































































































































































































































import { Component, Vue, PropSync, Watch, Prop } from 'vue-property-decorator'
import { 
  BModal, 
  BRow, 
  BCol, 
  BButton,
  BTabs,
  BTab,
  BBadge,
  BSpinner,
  BCard,
  BFormGroup,
  BFormFile,
  VBTooltip
} from 'bootstrap-vue'
import { Opportunite, OpportuniteLogStatut } from "@/api/models/opportunites/opportunite";
import moment from 'moment'
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import OpportunitesResource from '@/api/ressources/opportunites';
import { options } from '@fullcalendar/core/preact';

@Component({
  components: {
    BModal,
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BBadge,
    BSpinner,
    BCard,
    BFormGroup,
    BFormFile
  },
  directives: {
    'b-tooltip': VBTooltip
  }
})
export default class ViewOpportunite extends Vue {
  @PropSync('isViewOpportuniteModalActive', { type: Boolean, default: false })
  isModalVisible!: boolean

  @PropSync('opportuniteId', { type: String, default: '' })
  selectedOpportuniteId!: string

  @Prop({ type: Boolean, default: true })
  showActionButtons!: boolean

  opportunite: Opportunite | null = null

  newFiles: File[] = []
  showFullDetailsSource = false
  showFullRaisonPerte = false
  showFullEcheancier = false

  opportuniteLoading = false
  uploadingFiles = false

  listSourceOpportunites: {code: string, libelle: string}[] = []
  listTypeOpportunites: { code: string; libelle: string; }[] = []
  listNatureOffres: { code: string; libelle: string; }[] = []
  listTypePrestations: { code: string; libelle: string; }[] = []
  listStatuts: { code: string; libelle: string; }[] = []
  listRaisonsPerte: { code: string; libelle: string; }[] = []
  listEntiteFacturation: { code: string; libelle: string; }[] = []
  listNiveauConfiance: { code: string; libelle: string; }[] = []
  listEcheancierFacturation: { code: string; libelle: string; }[] = []
  listConditionPaiement: { code: string; libelle: string; }[] = []

  get sortedlogsStatut(): OpportuniteLogStatut[] {
    if (!this.opportunite?.logsStatut) return []
    
    return [...this.opportunite.logsStatut].sort((a, b) => {
      const dateA = a.start ? moment(a.start, 'DD/MM/YYYY').valueOf() : 0
      const dateB = b.start ? moment(b.start, 'DD/MM/YYYY').valueOf() : 0
      return dateB - dateA 
    })
  }

  async created() {
    await this.loadAllParametres()
  }

  @Watch('isModalVisible')
  async onModalVisibilityChanged(newVal: boolean) {
    if (newVal && this.selectedOpportuniteId) {
      await this.loadOpportunite()
    }
  }

  @Watch('selectedOpportuniteId')
  async onOpportuniteIdChanged(newVal: string) {
    if (newVal && this.isModalVisible) {
      await this.loadOpportunite()
    }
  }

  async loadOpportunite() {
    this.opportuniteLoading = true
    if (!this.selectedOpportuniteId) return

      await this.$http.myressif.entreprises.getOpportuniteById(
        this.$route.params.id,
        this.selectedOpportuniteId
      ).then((response: Opportunite) => {
        this.opportunite = response
      }).catch((error: any) => {
        console.error('Erreur lors du chargement de l\'opportunité :', error)
        errorAlert.fire({
          text: 'Une erreur est survenue lors du chargement de l\'opportunité.',
        });
        this.closeModal()
      }).finally(() => {
        this.opportuniteLoading = false
      })
  }

  async loadAllParametres() {
    await Promise.all([
      this.loadSourceOpportunites(),
      this.loadTypeOpportunites(),
      this.loadNatureOffre(),
      this.loadTypePrestation(),
      this.loadStatuts(),
      this.loadRaisonsPerte(),
      this.loadEntiteFacturation(),
      this.loadNiveauConfiance(),
      this.loadEcheancierFacturation(),
      this.loadConditionPaiement()
    ])
  }

  async loadParametre(parametre: string): Promise<{code: string, libelle: string}[]> {
    try {
      const res = await this.$http.myressif.parametres.getByNom(parametre)
      return res ? JSON.parse(res.valeur) : []
    } catch (error: any) {
      console.error(`Erreur lors du chargement du paramètre ${parametre}:`, error)
      return []
    }
  }

  async loadSourceOpportunites() {
    this.listSourceOpportunites = await this.loadParametre('opportunites_source_opportunite')
  }

  async loadTypeOpportunites() {
    this.listTypeOpportunites = await this.loadParametre('opportunites_type_opportunite')
  }

  async loadNatureOffre() {
    this.listNatureOffres = await this.loadParametre('opportunites_nature_offre')
  }

  async loadTypePrestation() {
    this.listTypePrestations = await this.loadParametre('opportunites_type_prestation')
  }

  async loadStatuts() {
    this.listStatuts = await this.loadParametre('opportunites_statut')
  }

  async loadRaisonsPerte() {
    this.listRaisonsPerte = await this.loadParametre('opportunites_raison_perte')
  }

  async loadEntiteFacturation() {
    this.listEntiteFacturation = await this.loadParametre('opportunites_entite_facturation')
  }

  async loadNiveauConfiance() {
    this.listNiveauConfiance = await this.loadParametre('opportunites_niveau_confiance')
  }

  async loadEcheancierFacturation() {
    this.listEcheancierFacturation = await this.loadParametre('opportunites_echeancier_facturation')
  }

  async loadConditionPaiement() {
    this.listConditionPaiement = await this.loadParametre('opportunites_condition_paiement')
  }

  getLibelleFromCode(code: string | undefined, list: {code: string, libelle: string}[]): string {
    if (!code) return '-'
    const item = list.find(i => i.code === code)
    return item ? item.libelle : code
  }

  formatDate(date: string): string {
    return moment(date).format('DD/MM/YYYY')
  }

  formatMontant(montant: number): string {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(montant)
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
  }

  getFileIcon(filename: string): string {
    const extension = filename.split('.').pop()?.toLowerCase()
    switch (extension) {
      case 'pdf':
        return 'FileTextIcon'
      case 'doc':
      case 'docx':
        return 'FileTextIcon'
      case 'xls':
      case 'xlsx':
        return 'GridIcon'
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'ImageIcon'
      case 'zip':
      case 'rar':
        return 'ArchiveIcon'
      default:
        return 'FileIcon'
    }
  }

  async downloadFile(piece: any) {
    await this.$http.myressif.entreprises
      .downloadOpportunitePieceJointe(
        this.opportunite?.entrepriseId,
        this.selectedOpportuniteId,
        piece.id
      )
      .then(
        async (response: any) => {
          window.open(response);
        },
        (error: any) => {
          if (error?.response?.data?.errors) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error.message,
            });
          }
        }
      );
  }

  deleteFile(piece: any, index: number) {
    this.$bvModal
      .msgBoxConfirm(`Êtes-vous sûr de vouloir supprimer le fichier "${piece.nom}" ?`, {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "danger",
        okTitle: "Supprimer",
        cancelTitle: "Annuler",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDeleteFile(piece.id, index)
        }
      })
  }

  async confirmDeleteFile(fileId: string, index: number) {
    await this.$http.myressif.entreprises.deleteOpportunitePieceJointe(
      this.opportunite!.entrepriseId,
      this.selectedOpportuniteId,
      fileId
    ).then(() => {
      if (this.opportunite && this.opportunite.piecesJointes) {
        this.opportunite.piecesJointes.splice(index, 1)
      }
      
      successAlert.fire({
        title: "Suppression d'une pièce jointe",
        text: "Fichier supprimé avec succès",
        timer: 2000,
      })
    }, (error: any) => {
        if (error?.response?.data?.errors) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error.message,
          });
        }
      }
    )
  }

  async uploadFiles(files: File[] | null) {
    if (!files || files.length === 0) return
    this.uploadingFiles = true

    await this.$http.myressif.entreprises
      .addOpportuniteEntreprisePiecesJointes(
        this.opportunite!.entrepriseId,
        this.selectedOpportuniteId,
        files
      ).then(async () => {
        successAlert.fire({
          title: "Upload de pièces jointes",
          text: `${files.length} fichier(s) ajouté(s) avec succès`,
          timer: 2000,
        })
        await this.loadOpportunite()
      },
      (error: any) => {
        if (error?.response?.data?.errors) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error.message,
          });
        }
      }
    ), (error: any) => {
      errorAlert.fire({
        text: error?.response?.data?.detail ?? error.message,
      })
    }    
    
    this.uploadingFiles = false
    this.newFiles = []
  }

  calculateDuration(start: string, end: string): string {
    const startDate = moment(start, 'DD/MM/YYYY')
    const endDate = moment(end, 'DD/MM/YYYY')
    const duration = moment.duration(endDate.diff(startDate))
    
    const years = Math.floor(duration.asYears())
    const months = Math.floor(duration.asMonths()) % 12
    const days = Math.floor(duration.asDays()) % 30
    
    const parts = []
    if (years > 0) parts.push(`${years} an${years > 1 ? 's' : ''}`)
    if (months > 0) parts.push(`${months} mois`)
    if (days > 0 && years === 0) parts.push(`${days} jour${days > 1 ? 's' : ''}`)
    
    return parts.length > 0 ? parts.join(', ') : '0 jour'
  }

  closeModal() {
    this.isModalVisible = false
    this.opportunite = null
    this.showFullDetailsSource = false
    this.showFullRaisonPerte = false
    this.showFullEcheancier = false
  }

  transformToContract() {
    if (this.$route.name === 'details-adherent' && this.$route.params.id === this.opportunite?.entrepriseId) {
      this.$emit('transform-to-contract-opportunite', this.selectedOpportuniteId)
      this.closeModal()
    } else {
      this.$router.push({
        name: 'details-adherent',
        params: { id: this.opportunite!.entrepriseId },
        query: { transformToContractOpportuniteId: this.selectedOpportuniteId }
      })
    }
  }

  editOpportunite() {
    var entrepriseId = this.opportunite!.entrepriseId
    
    this.$router.push({
      name: 'details-adherent',
      params: { id: entrepriseId },
      query: { editOpportunite: this.selectedOpportuniteId }
    })
  }

  deleteOpportunite() {
    this.askDelete(this.selectedOpportuniteId)
  }

  askDelete(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer cette opportunité ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.entreprises
      .deleteOpportuniteEntreprise(this.$route.params.id, id)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'un opportunite",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.closeModal()
        this.$emit('opportunite-deleted')
      });
  }
}
